import type { DelegationView } from "../api/connectionHub.types";
import { CONNECTION_STATUS } from "../constants/connectionStatus.constants";

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

const plural = (count: number, unit: string): string =>
  `${count} ${unit}${count === 1 ? "" : "s"}`;

export const formatDelegationValidity = (expiresAt: string | null): string | null => {
  if (!expiresAt) return null;
  const remaining = new Date(expiresAt).getTime() - Date.now();
  if (Number.isNaN(remaining)) return null;
  if (remaining <= 0) return "now expired";
  const minutes = Math.max(1, Math.round(remaining / MINUTE_MS));
  if (minutes < 60) return `valid for ${plural(minutes, "minute")}`;
  return `valid for ${plural(Math.max(1, Math.floor(remaining / HOUR_MS)), "hour")}`;
};

/** Server status wins; the timestamp is the fallback for when the backend has not recomputed status yet. */
export const isDelegationExpired = (delegation: DelegationView | null): boolean => {
  if (!delegation) return false;
  if (delegation.status === CONNECTION_STATUS.LINK_EXPIRED) return true;
  if (!delegation.expiresAt) return false;
  const remaining = new Date(delegation.expiresAt).getTime() - Date.now();
  return !Number.isNaN(remaining) && remaining <= 0;
};
